<template>
  <div>
    <img class="crisp-image" src="@/assets/images/ico061.svg" alt="Choose Lab Request">
    <text-string label-id="txt371"/>
  </div>
</template>

<script>
  export default {
    name: "modal-view-hipres-step-one"
  }
</script>

<style scoped>

</style>